import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ProjectOverviewStateService {
  private selectedView = 'new';
  private selectedPendingView = '';
  private selectedQuotationView = 'quotation';
  private selectedClientView = 'ongoing';

  public getSelectedView() {
    return this.selectedView;
  }

  public setSelectedView(selectedView: string) {
    this.selectedView = selectedView;
  }

  public getselectedPendingView() {
    return this.selectedPendingView;
  }

  public setselectedPendingView(selectedView: string) {
    this.selectedPendingView = selectedView;
  }

  public getSelectedQuotationView() {
    return this.selectedQuotationView;
  }

  public setSelectedQuotationView(selectedView: string) {
    this.selectedQuotationView = selectedView;
  }

  public getSelectedClientView() {
    return this.selectedClientView;
  }

  public setSelectedClientView(selectedClientView: string) {
    this.selectedClientView = selectedClientView;
  }
}
